import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  Output,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormBuilder,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { NavController } from "ionic-angular";
import { CompanyDetails } from "../company-details";

@Component({
  selector: "company-details-contacts",
  templateUrl: "company-details-contacts.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CompanyDetailsContacts),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CompanyDetailsContacts),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyDetailsContacts
  extends CompanyDetails
  implements ControlValueAccessor, OnDestroy
{
  @Input() isEditMode: boolean = false;
  @Input() fromLocationGroup: boolean = false;
  @Output() openFacility = new EventEmitter<any>();

  set value(value: any) {
    this.innerFormGroup.patchValue(value);
  }

  contacts = [
    {
      name: "Ffion Franklin",
      email: "ffranklin@easthospice.com",
      phone: "516-885-3043",
    },
    {
      name: "Ace Mackay",
      email: "amackay@easthostpice.com",
      phone: "917-676-7733",
    },
    {
      name: "Samina Penn",
      email: "spenn@easthostpice.com",
      phone: "914-273-5208",
    },
    {
      name: "Hetty Ibarra",
      email: "hmackay@easthostpice.com",
      phone: "718-459-1014",
    },
    {
      name: "Ruby-Mae East",
      email: "rbeast@easthostpice.com",
      phone: "315-743-5864",
    },
    {
      name: "Sonny Fountain",
      email: "sfountain@easthostpice.com",
      phone: "516-690-5882",
    },
    {
      name: "Shawn Walmsley",
      email: "swalmsley@easthostpice.com",
      phone: "315-266-9511",
    },
    {
      name: "Kaiden Field",
      email: "kfield@easthostpice.com",
      phone: "518-521-6235",
    },
    {
      name: "Kayne Chaney",
      email: "kchaney@easthostpice.com",
      phone: "631-367-5564",
    },
    {
      name: "Bentley Snider",
      email: "bsnider@easthostpice.com",
      phone: "631-915-0817",
    },
    {
      name: "Amit Howell",
      email: "ahowell@easthostpice.com",
      phone: "845-770-1159",
    },
    {
      name: "Kornelia Boone",
      email: "kboone@easthostpice.com",
      phone: "716-846-9106",
    },
    {
      name: "Jamal Higgins",
      email: "jhiggins@easthostpice.com",
      phone: "646-439-5588",
    },
    {
      name: "Delilah Garrison",
      email: "dgarrison@easthostpice.com",
      phone: "917-799-6951",
    },
  ];

  constructor(
    protected navCtrl: NavController,
    protected formBuilder: FormBuilder
  ) {
    super(formBuilder);

    // create inner form
    this.innerFormGroup = this.formBuilder.group({
      facilities: [[]],
    });

    this.subscriptions.push(
      this.innerFormGroup.valueChanges.subscribe((value) => {
        this.onChange(value);
        this.onTouched();
      })
    );
  }

  addContact(facility: any) {}

  openDetails(facility: any) {}

  changePage() {}
}



// WEBPACK FOOTER //
// ./src/pages/company/company-details/contacts/company-details-contacts.ts